import React, { useContext, useState } from "react";
import styles from "./style.module.scss";

import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";

import CardMarker from "../components/CardMarker/CardMarker";
import ReturnIcon from "../components/ReturnIcon/ReturnIcon";
import IconDisplayMenu from "../components/SelectedIcons/SelectedIcons";
import Modal from "../components/Modal/Modal";

import { MainContext } from "../context/MainContext";
import { MousePointer2Off } from "lucide-react";

import vaz from "../assets/image/vaz2114.png";
import fire1 from "../assets/image/f1.png";
import fire2 from "../assets/image/f2.png";
import fire3 from "../assets/image/f3.png";
import office from "../assets/image/office1.png";
import Irepair from "../assets/image/Irepair.png";

function Main() {
  const {
    buttons,
    setOpenModal,
    selectedMarker,
    setSelectedMarker,
    markers,
    userLocation,
    waypoints,
    setWaypoints,
    isStatusActiveIcon,
    user
  } = useContext(MainContext);

  const [openRoute, setOpenRoute] = useState(false);

  const handleWaypoints = (item) => {
    setWaypoints([
      ...waypoints,
      {
        latitude: item.coordinates[0],
        longitude: item.coordinates[1],
        name: item.name,
        address: item.address,
      },
    ]);
  };

  const resetRoute = () => {
    setWaypoints([]);
    setOpenRoute(false);
  };

  const openNavigator = () => {
    let webUrl;

    const latFrom = userLocation.latitude;
    const lonFrom = userLocation.longitude;
    const latTo = selectedMarker.coordinates[0];
    const lonTo = selectedMarker.coordinates[1];

    const waypointsStr = waypoints
      ?.map((point) => `${point.latitude},${point.longitude}`)
      .join("~");

    if (waypointsStr) {
      webUrl = `https://yandex.ru/maps/?rtext=${latFrom},${lonFrom}~${waypointsStr}~${latTo},${lonTo}&rtt=auto`;
    } else {
      webUrl = `https://yandex.ru/maps/?rtext=${latFrom},${lonFrom}~${latTo},${lonTo}&rtt=auto`;
    }

    if (navigator.userAgent.includes("iPhone")) {
      const yandexMapsUrl = `yandexmaps://?rtext=${latFrom},${lonFrom}~${latTo},${lonTo}`;
      window.location.href = yandexMapsUrl;
      setTimeout(() => {
        window.open(webUrl, "_blank");
      }, 2000);
    } else {
      setTimeout(() => {
        window.open(webUrl, "_blank");
      }, 1000);
    }
  };

  const filteredMarkers = React.useMemo(() => {
    if (!markers) return [];

    if (
      isStatusActiveIcon === true &&
      Array.isArray(user?.data.main_id) &&
      user.data.main_id.length > 0
    ) {
      return markers.filter((marker) => user.data.main_id.includes(marker.id));
    }

    return markers;
  }, [markers, isStatusActiveIcon, user?.data.main_id]);

  return (
    <div className={styles.map}>
      <IconDisplayMenu />
      <YMaps
        query={{ apikey: "728e9ad9-79f6-45bb-925f-3a0f2b990232", lang: "ru_RU" }}
        onError={(error) => console.error("Ошибка загрузки Yandex Maps API:", error)}
      >
        <div className={styles.map__container}>
          <Map
            options={{ suppressMapOpenBlock: true, copyrightsProvider: false }}
            className={styles.map__item}
            defaultState={{
              center: [userLocation.latitude, userLocation.longitude],
              zoom: 14,
            }}
          >
            <Placemark
              geometry={[54.89128509863215, 38.06351193831382]}
              options={{
                iconLayout: "default#image",
                iconImageHref: office,
                iconImageSize: [85, 85],
                iconImageOffset: [-10, -10],
              }}
            />
            {userLocation.latitude && (
              <Placemark
                geometry={[userLocation.latitude, userLocation.longitude]}
                options={{
                  iconLayout: "default#image",
                  iconImageHref: vaz,
                  iconImageSize: [45, 35],
                  iconImageOffset: [-10, -10],
                }}
              />
            )}
            {filteredMarkers.map(
              (marker) =>
                ReturnIcon(
                  marker.repair,
                  marker.last_to,
                  fire1,
                  fire2,
                  fire3,
                  Irepair,
                  buttons,
                  marker.id,
                ) !== null && (
                  <Placemark
                    key={marker.id}
                    geometry={marker.coordinates}
                    options={{
                      iconLayout: "default#image",
                      iconImageHref: marker.repair
                        ? Irepair
                        : ReturnIcon(
                            marker.repair,
                            marker.last_to,
                            fire1,
                            fire2,
                            fire3,
                            Irepair,
                            buttons,
                          ),
                      iconImageSize: [40, 48],
                      iconImageOffset: [-15, -15],
                    }}
                    onClick={() => setSelectedMarker(marker)}
                  />
                ),
            )}

          </Map>
        </div>
      </YMaps>

      {openRoute && (
        <Modal setOpenModal={setOpenModal} onClose={setOpenRoute}>
          <div className={styles.modal__wrapper}>
            <div className={styles.modal__title_container}>
              <h2 className={styles.modal__title}>Детали Маршрута</h2>
            </div>
            <div className={styles.modal__container}>
              <p className={styles.modal__route__start}>Старт: Мое месторасположение</p>
              {waypoints.map((point, index) => (
                <div key={index} className={styles.route__waypoints}>
                  <p className={styles.modal__route_text}>
                    Точка {index + 1}: {point.name}
                  </p>
                  <p className={styles.modal__route_text}>Адрес: {point.address}</p>
                </div>
              ))}
            </div>
            <button className={styles.modal__button_close} onClick={resetRoute}>
              <MousePointer2Off color="#ff0e00" size={28} />
              Сбросить Маршрут
            </button>
          </div>
        </Modal>
      )}
      {selectedMarker && (
        <CardMarker
          selectedMarker={selectedMarker}
          setSelectedMarker={setSelectedMarker}
          handleRoute={openNavigator}
          handleWaypoints={handleWaypoints}
        />
      )}
      {waypoints.length > 0 && (
        <button className={styles.modal__route} onClick={() => setOpenRoute(true)}>
          <p>Маршрут</p>
        </button>
      )}
      <span className={styles.map__status_bar} />
    </div>
  );
}

export default Main;
